import * as React from 'react';
import { cn } from '@/lib/utils';

export type TomVariant =
  | 'walking-on'
  | 'pointing-right'
  | 'writing-board'
  | 'inspecting-clipboard'
  | 'checking-list'
  | 'welcoming'
  // V1.1 (2026-04-27): pose library expansion for the Bridge page. PNG finalists are
  // source-locked under docs/design/character-system/poses/ + served from
  // public/character-system/poses/. Allocation per the Bridge prompt pack §0.
  | 'listening'
  | 'thumbs-up'
  | 'hands-on-hips';

const SRC: Record<TomVariant, string> = {
  'walking-on':    '/character-system/poses/tom-01-walking-on-v1.png',
  'pointing-right':'/character-system/poses/tom-01-pointing-right-v1.png',
  'writing-board': '/character-system/poses/tom-01-writing-board-v1.png',
  'inspecting-clipboard': '/character-system/poses/tom-01-inspecting-clipboard-v1.png',
  'checking-list': '/character-system/poses/tom-01-checking-list-v1.png',
  'welcoming': '/character-system/poses/tom-01-welcoming-v1.png',
  'listening':     '/character-system/poses/tom-01-listening-v1.png',
  'thumbs-up':     '/character-system/poses/tom-01-thumbs-up-v1.png',
  'hands-on-hips': '/character-system/poses/tom-01-hands-on-hips-v1.png',
};

const ALT: Record<TomVariant, string> = {
  'walking-on':    'Tom walking on',
  'pointing-right':'Tom pointing right',
  'writing-board': 'Tom writing on a marker board',
  'inspecting-clipboard': 'Tom inspecting a clipboard',
  'checking-list': 'Tom checking a list',
  'welcoming': 'Tom welcoming the Builder',
  'listening':     'Tom seated and listening',
  'thumbs-up':     'Tom giving a thumbs-up',
  'hands-on-hips': 'Tom standing with hands on hips',
};

export interface TomProps extends Omit<React.ImgHTMLAttributes<HTMLImageElement>, 'src' | 'alt'> {
  variant: TomVariant;
  alt?: string;
}

/**
 * Tom — the AI Co-Founder. Race bib 01, teal accent.
 * Locked PNG poses live at /character-system/poses/.
 * Each pose is hand-drawn marker on transparent background.
 */
export const Tom = React.forwardRef<HTMLImageElement, TomProps>(
  ({ variant, alt, className, ...rest }, ref) => (
    <img
      ref={ref}
      src={SRC[variant]}
      alt={alt ?? ALT[variant]}
      className={cn('block select-none', className)}
      draggable={false}
      {...rest}
    />
  ),
);
Tom.displayName = 'Tom';
